import { registerPlugin } from '@capacitor/core';

// Define interface for the FileExport plugin
export interface FileExportPlugin {
  saveFile(options: {
    data: string;
    filename: string;
    mimeType?: string; 
  }): Promise<{
    success: boolean;
    path?: string;
  }>;
  
  setupBridge(): Promise<void>;
}

// Register the plugin
const FileExport = registerPlugin<FileExportPlugin>('FileExport');

export default FileExport; 